export default {
    methods: {
        showSnack(text = 'Текст не задан', color = 'success', timeout = 3000, vertical = false, close = false, top = true) {
            const time = color === 'warning' ? 6000 : timeout
            this.$store.commit('common/setSnack', {
                text: text,
                color: color,
                timeout: time,
                vertical: vertical,
                close: close,
                top: top
            })
        }
    }
}